/**
 * @description: 走马灯设置
 * @author: fire
 * @update: hwx
 */
<template>
    <div class="zoumadeng-set">
        <div class="zmd-list" v-show="showList">
            <div class="row row-margin">
                <button type="button" class="btn btn-flat btn-small bg-orange" @click="addZmd()">走马灯设置</button>
            </div>
            <div class="row">
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zmd_shop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-4">包厢区域:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zmd_area" data-placeholder="请选择包厢区域" disabled>
                    </select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zmd_box" data-placeholder="请选择包厢号" disabled>
                    </select>
                </div>
                <label class="list-label-2">状态:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="zmd_status">
                        <option value=" ">全部</option>
                        <option value="1">启用</option>
                        <option value="-1">禁用</option>
                    </select>
                </div>
                <div class="pull-right">
                    <button type="button" class="btn bg-orange btn-flat btn-small" @click="queryList()">查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table ref="zmd_list" class="table table-bordered table-hover" data-pagination="true"></table>
            </div>
        </div>
        <!-- 添加、修改 -->
        <div class="zmd-edit" v-show="showEdit">
            <div class="page-tit">{{add_header}}</div>
            <p>注：走马灯播放内容在包厢点视频顶部显示</p>
            <div class="row">
                <label class="ctr-label-left">门店:</label>
                <div class="col-md-4 ct-col">
                    <select class="form-control" ref="edit_shop" data-placeholder="请选择门店"></select>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">播放序号:</label>
                <div class="col-md-4">
                    <input class="form-control" v-model="edit_play_number" ref="edit_play_number" placeholder="请输入走马灯播放序号：例如01、02、03">
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">播放内容:</label>
                <div class="col-md-4">
                    <textarea class="form-control play_content" v-model="edit_play_content" ref="edit_play_content" placeholder="欢迎使用巨嗨ktv自助点歌系统，开启您的k歌之旅！"></textarea>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">字体颜色:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择字体颜色" v-model="edit_font_color" ref="edit_font_color" readonly @click="zmdFontFun($event)">
                    <span class="selection-clear" @click="clear_input('edit_font_color')">×</span>
                    <span class="span-arrow" role="presentation">
                        <b role="presentation"></b>
                    </span>
                </div>
            </div>
            <div class="row add-play-date">
                <label class="ctr-label-left">播放日期:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" v-model="edit_play_date"  placeholder="请选择播放日期" ref="edit_play_date" readonly>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">播放时间:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" v-model="edit_play_time" ref="edit_play_time" placeholder="请选择播放时间" readonly="readonly" @click="chooseTimePop()">
                    <span class="selection-clear" @click="clear_input('edit_play_time')">×</span>
                    <span class="span-arrow" role="presentation"><b role="presentation"></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">区域:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="edit_area" ref="edit_area" readonly @click="zmdAreaFun($event)">
                    <span class="selection-clear" @click="clear_input('edit_area')">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">包厢号:</label>
                <div class="col-md-4">
                    <input class="form-control input-readonly" placeholder="请选择需要包厢号" v-model="edit_box" ref="edit_box" readonly  @click="zmdBoxFun($event)">
                    <span class="selection-clear" @click="clear_input('edit_box')">×</span>
                    <span class="span-arrow" role="presentation">
                        <b role="presentation"></b>
                    </span>
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">播放频率:</label>
                <div class="col-md-4">
                  <div class="add_play_frequency_company" style="">分钟/次</div>
                  <input class="form-control" v-model.trim="edit_play_frequency" ref="edit_play_frequency" placeholder="请输入走马灯播放的频率，例如5分钟/次">
                </div>
            </div>
            <div class="row">
                <label class="ctr-label-left">字体大小:</label>
                <div class="col-md-4">
                    <input class="form-control" v-model.trim="edit_font_size" placeholder="请输入字体大小">
                </div>
                <span class="rmarkspan" titles="建议字体大小设置范围为：30-50" @mouseenter="hint_language($event, 2)" @mouseleave="close_hint_language"></span>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editZmd" v-show="modify != '3'">保存</button>
            </div>
        </div>
        <!-- 时间选择弹窗 -->
        <div class="use-time-wrap" ref="zmd_use_time">
            <h2>开始时间：</h2>
            <select ref="starthour"></select>
            <label class="colon">:</label>
            <select ref="startseconds"></select>
            <h2>结束时间：</h2>
            <select ref="stophour" id="stophour"></select>
            <label class="colon">:</label>
            <select ref="stopseconds"></select>
        </div>
        <!-- 字体颜色区域 -->
        <div class="ele-hide" ref="font_color_confirm">
            <div class="multi-select">
                <ul class="clearfix">
                    <li v-for="item in font_arr">
                        <input type="radio" :id="item.name" v-model='font_item' :value="item.id">
                        <label :for="item.name">{{item.name}}</label>
                        <i :class="'color_' + item.id" ></i>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 区域 -->
        <div class="ele-hide" ref="zoumadeng_area">
            <div class="multi-select">
                <div class="clearfix">
                    <input type='checkbox' v-model='area_all' @click='areaAllCheck'>
                    <span>全选</span>
                </div>
                <ul class="clearfix">
                    <li v-for="item in area_arr">
                        <input type="checkbox" name="shop_area" v-model='area_item' :value="item.id">
                        <span>{{item.name}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <!--包厢号-->
        <div class="multi-page" ref="box_area" v-show="showBox">
            <div class="page-tit">包厢范围</div>
            <p>请选择包厢范围</p>
            <div class="room-wrapper">
                <div class="block-title">
                    <el-checkbox v-model="checkAllBox" @change="handleCheckAllBoxChange">全选</el-checkbox>
                </div>
                <div class="block" v-for="(item,pindex) in box_arr">
                    <div class="block-title">
                        <el-checkbox @change="checked=>handleCheckArea(checked,pindex)" v-model="item.checked">{{item.room_area_name}}</el-checkbox>
                    </div>
                    <el-checkbox-group class="rooms" v-model="choosedBox">
                        <el-checkbox class="room" 
                        v-for="(room,cindex) in item.room" 
                        :label="room.id" 
                        :key="room.id" 
                        @change="checked=>handleCheckBox(checked,pindex,cindex)">{{room.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <el-button @click="backEdit">返回</el-button>
            <el-button type="primary" @click="boxSub">确认</el-button> 
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'zoumadeng-set',
        data() {
            return {
                showList: true,
                showEdit: false,
                room_id: "",
                edit_play_number: "",  // 播放序号
                edit_play_content: "", // 播放内容
                edit_font_color: "",

                area_all: false,
                c_area_all: false,
                font_item: null,
                // 颜色，1绿色 2白色 3红色 4橙色 5蓝色 6黄色 7紫色
                font_arr: [{
                    id: 1,
                    name: "绿色"
                }, {
                    id: 2,
                    name: "白色"
                }, {
                    id: 3,
                    name: "红色"
                }, {
                    id: 4,
                    name: "橙色"
                }, {
                    id: 5,
                    name: "蓝色"
                }, {
                    id: 6,
                    name: "黄色"
                }, {
                    id: 7,
                    name: "紫色"
                }],
                edit_play_date: "",
                add_play_dateModel: "",
                editAllParams: {
                    id: "",
                    room_type_name: "",
                    room_type: [],
                    type_name: "",
                    package_time: "",
                    time_cost_price: "",
                    week_cycle: "",
                    week_cycle_str: "",
                    start_time: "",
                    end_time: "",
                },
                edit_play_frequency: "",
                edit_font_size: '',
                area_arr: [],
                area_item: [],
                edit_area:"",
                box_arr:[],
                box_item:[],
                choosedBox: [],
                checkAllBox: false,
                showBox: false,
                edit_box: "",
                add_header: "走马灯设置",
                modify: 1,
                theBrinter: {
                    type: Object
                },

                room_detailcheckboxdata:[],
                all_shops: '1',
            }
        },
        computed: {
            edit_play_time() {
                let _this = this;
                return _this.editAllParams.start_time + "-" + _this.editAllParams.end_time;
            },
        },
        watch: {
            area_item: {
                handler: function(val, oldval) {
                    if(this.area_item.length >= this.area_arr.length) {
                        this.area_all = true;
                        this.c_area_all = true;
                    } else {
                        this.area_all = false;
                        this.c_area_all = false;
                    }
                },
                deep: true
            },

            edit_area: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.edit_area).parent().find('.selection-clear').show();
                        $(this.$refs.edit_box).prop("disabled", true);
                    } else {
                        $(this.$refs.edit_area).parent().find('.selection-clear').hide();
                        $(this.$refs.edit_box).prop("disabled", false);
                    }
                },
                deep: true
            },
            edit_box: {
                handler: function(val, oldval) {
                    if(val != "") {
                        $(this.$refs.edit_area).prop("disabled", true);
                        $(this.$refs.edit_box).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.edit_area).prop("disabled", false);
                        $(this.$refs.edit_box).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            this.$nextTick(function() {
                let _this = this;
                _this.getshopdata();
                _this.selectTime();
                _this.initDate();
                $(_this.$refs.zmd_status).select2({
                    minimumResultsForSearch: -1,
                    language: "zh-CN",
                    width: '100%'
                });
            });
        },
        methods: {
            // 修改页的提示语
            hint_language: function(e, num) {
                var contents = "<span class='dots'>·</span>" + $(e.currentTarget).attr("titles");
                layer.tips(contents, $(e.currentTarget), {
                    skin: 'hint_language_tip',
                    tips: [num, '#fff'],
                    area: ['400px', ''],
                    time: 2000000,
                });
            },
            // 关闭提示语
            close_hint_language: function() {
                layer.closeAll('tips');
            },
            // 门店数据
            getshopdata: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {}
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let shopDatas = [];
                            $.each(data.response.result, function(k, v) {
                                shopDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.zmd_shop).select2({
                                data: shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.zmd_area).prop("disabled", true);
                                    _this.initi_room_id('');
                                    $(_this.$refs.zmd_box).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.zmd_area).prop("disabled", false);
                                _this.getboxdata(e.params.data.id);
                                $(_this.$refs.zmd_box).prop("disabled", false);
                                _this.getRoomIdData(e.params.data.id);
                            });
                            $(_this.$refs.zmd_shop).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.zmd_area).prop("disabled", false);
                            _this.getboxdata(data.response.result[1].id);
                            $(_this.$refs.zmd_box).prop("disabled", false);
                            _this.getRoomIdData(data.response.result[1].id);

                            _this.initTable();

                            // shopDatas.shift();
                            $(_this.$refs.edit_shop).select2({
                                data: shopDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            }).on("select2:select",function(e) {
                                console.log('e',e);
                                if(e.params.data.id != '0'){
                                    _this.all_shops = '-1';
                                    _this.getboxdata(e.params.data.id, false);
                                    _this.edit_area = "";
                                    _this.area_item = [];
                                    $(_this.$refs.edit_area).prop("disabled", false);
                                    _this.edit_box = "";
                                    _this.box_item = [];
                                    $(_this.$refs.edit_box).prop("disabled", false);
                                }else{
                                    _this.all_shops = '1';
                                    _this.edit_area = "全部";
                                    _this.area_item = [];
                                    $(_this.$refs.edit_area).prop("disabled", true);
                                    _this.edit_box = "全部";
                                    _this.box_item = [];
                                    $(_this.$refs.edit_box).prop("disabled", true);
                                }

                               
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 区域
            getboxdata: function(shopid, type) {
                let _this = this;
                
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getRoomArea",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let boxdatas = [{ id: " ", text: "全部" }];
                            if(type == false) {
                                _this.area_arr = data['response']['result'];
                                return;
                            }
                            $.each(data['response']['result'], function(k, v) {
                                boxdatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(boxdatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            initi_list_box: function(boxdatas) {
                $(this.$refs.zmd_area).html("");
                $(this.$refs.zmd_area).select2({
                    data: boxdatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 包厢号
            getRoomIdData: function(shopid, type) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomIdDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomIdDatas.push({ id: v.id, text: v.name });
                            });
                            _this.initi_room_id(roomIdDatas);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            initi_room_id: function(roomIdDatas) {
                $(this.$refs.zmd_box).html("");
                $(this.$refs.zmd_box).select2({
                    data: roomIdDatas,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },

            // 列表
            initTable: function() {
                let _this = this;

                $(_this.$refs.zmd_list).bootstrapTable("destroy");
                $(_this.$refs.zmd_list).bootstrapTable({
                    pageSize: 10,
                    pageList: [],
                    ajax: function(params) {
                        _this.getzoumadenglistdata(params);
                    },
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        width: "3%",
                        field: "number",
                        title: "播放序号"
                    }, {
                        width: "8%",
                        field: "shop_name",
                        title: "门店"
                    }, {
                        width: "8%",
                        field: "content",
                        title: "播放内容",
                        formatter: function(value, row, index) {
                            if (value.length > 20) {
                                return value.substring(0, 20) + '...'
                            }else {
                                return value
                            }
                        }
                    }, {
                        width: "8%",
                        field: "start_date",
                        title: "播放日期",
                        formatter: function(value, row, index) {
                            if( row["play_times"] == "1") {
                                return "每天";
                            } else {
                                return row["start_date"] + "-" + row["end_date"]; 
                            }
                        }
                    }, {
                        width: "8%",
                        field: "start_time",
                        title: "播放时间",
                        formatter: function (value, row, index) {
                            return row["start_time"] + "-" + row["end_time"];
                        }
                    }, {
                        width: "8%",
                        field: "room_area",
                        title: "区域"
                    }, {
                        width: "8%",
                        field: "room_id",
                        title: "包厢号"
                    }, {
                        width: "8%",
                        field: "play_frequency",
                        title: "播放频率"
                    }, {
                        width: "8%",
                        field: "status",
                        title: "状态",
                        formatter: function(value, row, index) {
                            if(row["status"] == "1") {
                                return "启用";
                            } else {
                                return "禁用";
                            }
                        }
                    }, {
                        width: "18%",
                        title: "操作",
                        events: {
                            'click .modify': function(e, value, row, index) {
                                _this.modify = 2;
                                // _this.addZmd();
                                _this.getZoumadengDetail(row.id);
                            },
                           'click .oper': function(e, value, row, index) {
                                var status = ( row["status"] == "1" ) ? "-1" : "1";
                                _this.onOffZoumadeng(row["id"], status);
                            },
                            'click .details': function(e, value, row, index) {
                                _this.modify = 3;
                                // _this.addZmd();
                                _this.getZoumadengDetail(row.id);
                            },
                            'click .del': function(e, value, row, index) {
                                layer.confirm('删除后不可恢复，确定删除？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.onOffZoumadeng(row["id"], '-2');
                                });
                            }
                        },
                        formatter: function (value, row, index) {
                            var status_name = row["status"]==1 ? "禁用" : "启用";
                            return [
                                '<div class="orange-text">',
                                '<a class="modify">修改</a>',
                                '<a class="oper">' + status_name + '</a>',
                                '<a class="details">详情</a>',
                                '<a class="del">删除</a>'
                            ].join('');
                        }
                    }]
                });
            },
            getzoumadenglistdata: function(params) {
                let _this = this,
                    pageNumber = 1;

                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": pageNumber,
                            "page_size": "10",
                            "shop_id": $(_this.$refs.zmd_shop).val(),
                            "room_area": $.trim($(_this.$refs.zmd_area).val()),
                            "room_id": $.trim($(_this.$refs.zmd_box).val()),
                            "status": $.trim($(_this.$refs.zmd_status).val())
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/getScrollingTextList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            params.success({
                                total: data['response']['result']['count'],
                                rows: data['response']['result']["data"]
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.close(layIndex);
                    }
                });
            },
            // 点击“查询”按钮
            queryList: function() {
                this.initTable();
            },
            // 禁用、启用、删除走马灯
            onOffZoumadeng: function(id, status) {
                var _this = this;
                var datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": id,
                            "status": status
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setScrollingTextStatus",
                    async:false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true"){
                            $(_this.$refs.zmd_list).bootstrapTable('refresh');
                            layer.msg(data["response"]["error_msg"]);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 添加走马灯
            addZmd: function() {
                let _this = this;

                _this.showList = false;
                _this.showEdit = true;
                _this.modify = 1;
                $('.zmd-edit select').prop("disabled", false);
                $('.zmd-edit input').prop("disabled", false);
                $('.zmd-edit textarea').prop("disabled", false);
                _this.add_data_initi(); // 添加走马灯数据初始化
            },
            // 添加走马灯数据初始化
            add_data_initi: function () {
                let _this = this;

                $(_this.$refs.edit_shop).val('').trigger('change');
                _this.edit_play_number = "";
                _this.edit_play_content = "";
                // 字体颜色
                _this.edit_font_color = "绿色";  // 默认为绿色
                _this.font_item = 1;  // 默认为绿色
                // 播放日期
                _this.startDate = "";
                _this.endDate = "";
                _this.edit_play_date = '';
                _this.add_play_dateModel = "";
                $(".add-play-date #add_play_date_everyday").attr("checked", false);
                $(".add-play-date #add_play_date_everyday").val(0);
                // 播放时间
                _this.editAllParams.start_time = "";
                _this.editAllParams.end_time = "";
                _this.all_shops = '1';
                // 区域
                // _this.getboxdata($(_this.$refs.edit_shop).val(), false);
                _this.edit_area = "全部";
                _this.area_item = [];
                $(_this.$refs.edit_area).prop("disabled", true);
                // 包厢号
                _this.edit_box = "全部";
                _this.box_item = [];
                $(_this.$refs.edit_box).prop("disabled", true);

                _this.edit_play_frequency = "";
                _this.edit_font_size = "40";
            },
            // 清空多选
            clear_input: function(name) {
                if(name == "edit_box") {
                    this.edit_box = "";
                    this.box_item = [];
                } else if(name == "edit_area") {
                    this.edit_area = "";
                    this.area_item = [];
                }
            },
            // 字体颜色
            zmdFontFun: function(e) {
                let _this = this;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['字体颜色', true],
                    area: ['500px', ''], // 宽高
                    content: $(this.$refs.font_color_confirm),
                }, function() {
                    let text = "";
                    _this.font_arr.forEach(function(item) {
                        if(item.id == _this.font_item) {
                            _this.font_item = item.id;
                            text = item.name;
                        }
                    });
                    _this.edit_font_color = text;
                    layer.closeAll();
                });
            },
            // 日期
            initDate: function() {
                let _this = this;
                $(_this.$refs.edit_play_date).daterangepicker({
                    parentEl: '.add-play-date',
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                }, function(start, end, label) {
                    _this.startDate = start.format('YYYY-MM-DD');
                    _this.endDate = end.format('YYYY-MM-DD');
                    if($(".add-play-date #add_play_date_everyday").val() == 1) {
                        $(_this.$refs.edit_play_date).val("每天");
                        _this.edit_play_date = '每天';
                        _this.add_play_dateModel = 1;
                        return;
                    }
                    _this.edit_play_date = _this.startDate + ' - ' + _this.endDate;
                    _this.add_play_dateModel = -1;
                });

                $(".add-play-date .daterangepicker:last").find(".ranges").prepend(
                    '<div class="add_play_date_everyday_div">' +
                        '<input id="add_play_date_everyday" type="radio" name="add_play_date_everyday" class="add_play_date_everyday">' +
                        '<label >每天</label>' +
                    '</div>'
                );

                $(".add-play-date #add_play_date_everyday").click(function() {
                    if($(this).val() == "1") {
                        $(this).attr("checked", false);
                        $(this).val(0);
                    } else {
                        $(this).attr("checked", true);
                        $(this).val(1);
                    }
                });
            },
            // 时间
            chooseTimePop: function() {
                let _this = this;
                $(_this.$refs.starthour).val(_this.editAllParams.start_time.split(':')[0]).trigger('change');
                $(_this.$refs.startseconds).val(_this.editAllParams.start_time.split(':')[1]).trigger('change');
                $(_this.$refs.stophour).val(_this.editAllParams.end_time.split(':')[0]).trigger('change');
                $(_this.$refs.stopseconds).val(_this.editAllParams.end_time.split(':')[1]).trigger('change');
                layer.confirm('', {
                    type: 1,
                    skin: 'public-alert-skin',
                    btn: ['确定', '取消'], // 按钮
                    title: '使用时间选择',
                    area: ['450px', ''], // 宽高
                    content: $(_this.$refs.zmd_use_time)
                }, function() {
                    _this.createTimeString();
                    layer.closeAll();
                });
            },
            // 获取时间
            selectTime: function() {
                let _this = this;

                let seconds = [];
                for(let i = 0; i < 60; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    seconds[i] = item;
                };
                let hour = [];
                for(let i = 0; i < 24; i++) {
                    let item = {};
                    item.id = (i < 10) ? '0' + i : i;
                    item.text = (i < 10) ? '0' + i : i;
                    hour[i] = item;
                }
                $(_this.$refs.starthour).select2({
                    data: hour,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.startseconds).select2({
                    data: seconds,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.stophour).select2({
                    data: hour,
                    language: "zh-CN",
                    width: 'auto'
                });
                $(_this.$refs.stopseconds).select2({
                    data: seconds,
                    language: "zh-CN",
                    width: 'auto'
                })
            },
            // 获取选择的时间
            createTimeString() {
                let _this = this;
                let starthour = $(_this.$refs.starthour).select2("val");
                let startseconds = $(_this.$refs.startseconds).select2("val");
                let stophour = $(_this.$refs.stophour).select2("val");
                let stopseconds = $(_this.$refs.stopseconds).select2("val");
                _this.editAllParams.start_time = starthour + ":" + startseconds;
                _this.editAllParams.end_time = stophour + ":" + stopseconds;
            },
            // 区域
            zmdAreaFun: function(e) {
                let _this = this;
                let c_area_item = _this.area_item;

                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['包厢区域', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.zoumadeng_area),
                    cancel: function() {
                        // 右上角关闭
                        if(_this.edit_area != "") {
                            _this.area_item = c_area_item;
                            return;
                        }
                        _this.area_item = [];
                    }
                }, function() {
                    let texts = [];
                    _this.area_arr.forEach(function(item) {
                        _this.area_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.edit_area = texts.join(",");
                    layer.closeAll();
                }, function() {
                    if(_this.edit_area != "") {
                        _this.area_item = c_area_item;
                        return;
                    }
                    _this.area_item = [];
                });
            },
            // 全选
            areaAllCheck: function() {
                let _this = this;
                _this.area_all = _this.c_area_all;
                if(!_this.area_all) { // 实现全选
                    _this.area_item = [];
                    _this.area_arr.forEach(function(item) {
                        _this.area_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.area_item = [];
                }
            },
            // 包厢号
            zmdBoxFun: function(e) {
                let _this = this;
                
                _this.getAllRoomByArea($(_this.$refs.edit_shop).val());
                _this.showEdit = false;
                _this.showBox = true;
            },
            getAllRoomByArea: function(shopid) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shopid||""
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoomByArea",
                    async:false,
                    crossDomain: true,
                    xhrFields: {
                      withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            _this.box_arr = data['response']['result'];
                            _this.formatChoosedRoom(_this.box_item)
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 格式化已选择包厢
            formatChoosedRoom(ids) {
                this.choosedBox = ids
                this.checkAllBox = false
                let choosedRoomName = []
                
                if (ids.length > 0) { // 判断区域全选状态
                    this.box_arr.forEach((item, pindex) => {
                        item.choosedCount = 0
                        this.box_arr[pindex].checked = false
                        item.room.forEach((room, cindex) => {
                            ids.forEach(v => {
                                if (v == room.id) {
                                    item.choosedCount ++
                                    choosedRoomName.push(room.name)
                                }
                            })
                        })
                        if (item.choosedCount == item.room.length) {
                            this.box_arr[pindex].checked = true
                        }
                    })
                    this.edit_box = choosedRoomName.join(",")
                }
                this.is_allChoosed()
            },

            // 选择/取消某个区域
            handleCheckArea(val, pindex) {
                if (val) {
                    this.box_arr[pindex].room.forEach(item => {
                        let cindex = this.choosedBox.findIndex(val => val == item.id)
                        if (cindex < 0) {
                            this.choosedBox.push(item.id)
                        }
                    })
                    this.is_allChoosed()
                }else {
                    this.box_arr[pindex].room.forEach(item => {
                        let cindex = this.choosedBox.findIndex(val => val == item.id)
                        if (cindex > -1) {
                            this.choosedBox.splice(cindex, 1)
                        }
                    })
                    // 取消全选
                    this.checkAllBox = false
                }
            },

            // 选择/取消某个包厢
            handleCheckBox(val, pindex, cindex) {
                let areaAllRoom = this.box_arr[pindex].room
                let areaRoomCount = 0
                this.box_arr[pindex].room.forEach(item => {
                    let chooseIndex = this.choosedBox.findIndex(id => id == item.id)
                    if (chooseIndex > -1) {
                        areaRoomCount ++
                    }
                })
                this.box_arr[pindex].checked = areaRoomCount == areaAllRoom.length

                if (!val) { // 取消全选
                    this.checkAllBox = false
                }else {
                    this.is_allChoosed()
                }
            },

            // 适用包厢全选
            handleCheckAllBoxChange(val) {
                if (val) {
                    this.box_arr.forEach(item => {
                        item.checked = true
                        item.room.forEach(v => {
                            let cindex = this.choosedBox.findIndex(val => val == v.id)
                            if (cindex < 0) {
                                this.choosedBox.push(v.id)
                            }
                        })
                    })
                }else {
                    this.box_arr.forEach(item => {
                        item.checked = false
                    })
                    this.choosedBox = []
                }
            },

            // 计算是否全选
            is_allChoosed() {
                let count = 0
                this.box_arr.forEach(item => {
                    if (item.checked) {
                        count ++
                    }
                })
                this.checkAllBox = count == this.box_arr.length
            },

            // 确认选择包厢
            boxSub: function() {
                this.box_item = this.choosedBox
                if (this.box_item.length < 1) {
                    this.edit_box = ''
                }else {
                    let room_name = []
                    this.box_item.forEach(item => {
                        this.box_arr.forEach(parent => {
                            parent.room.forEach(v => {
                                if (v.id == item) {
                                    room_name.push(v.name)
                                }
                            })
                        })
                    })
                    this.edit_box = room_name.join(",")
                }
                this.showEdit = true;
                this.showBox = false;
            },
            // 返回
            backEdit: function() {
                this.showEdit = true;
                this.showBox = false;
            },
            // 详情
            getZoumadengDetail: function(zoumadengid) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "id": zoumadengid || "",
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"Setting/getScrollingTextDetail",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            if(_this.modify == '3') {
                                $('.zmd-edit select').prop("disabled", true);
                                $('.zmd-edit input').prop("disabled", true);
                                $('.zmd-edit textarea').prop("disabled", true);
                            } else {
                                $('.zmd-edit select').prop("disabled", false);
                                $('.zmd-edit input').prop("disabled", false);
                                $('.zmd-edit textarea').prop("disabled", false);
                            }

                            let result = data['response']['result'];
                            _this.theBrinter = result;
                            $(_this.$refs.edit_shop).val(result.shop_id).trigger("change");
                            _this.edit_play_number = result.number;
                            _this.edit_play_content = result.content;
                            _this.font_item = result.color;

                            let text = "";
                            _this.font_arr.forEach(function(item) {
                                if ( item.id == _this.font_item ) {
                                    text = item.name;
                                }
                            });
                            _this.edit_font_color = text;
                            _this.add_play_dateModel = result.play_times;
                            // 日期
                            if ( _this.add_play_dateModel == "1" ) {
                                _this.edit_play_date = '每天';
                                _this.add_play_dateModel = '1';
                                $(".add-play-date #add_play_date_everyday").attr("checked", true);
                                $(".add-play-date #add_play_date_everyday").val(1);
                            } else {
                                let start_date = result.start_date.replace(/\./g, "-");
                                let end_date = result.end_date.replace(/\./g, "-");
                                _this.edit_play_date = start_date + " - " + end_date;
                                _this.add_play_dateModel = '-1';
                                _this.startDate = start_date;
                                _this.endDate = end_date;
                                $(".add-play-date #add_play_date_everyday").attr("checked", false);
                                $(".add-play-date #add_play_date_everyday").val(0);
                            }
                            if(result.all_shops == '1'){
                                _this.all_shops = '1';
                                _this.edit_area = "全部";
                                _this.area_item = [];
                                $(_this.$refs.edit_area).prop("disabled", true);
                                _this.edit_box = "全部";
                                _this.box_item = [];
                                $(_this.$refs.edit_box).prop("disabled", true);
                            }else{
                                _this.all_shops = '-1';
                                _this.getboxdata(result.shop_id, false);
                                _this.edit_area = result.room_area_name;
                                _this.edit_box = result.room_name;
                                _this.area_item = result.room_area;
                                _this.box_item = result.room_id;
                            }
                            _this.editAllParams.start_time = result.start_time;
                            _this.editAllParams.end_time = result.end_time;
                            _this.edit_play_frequency = result.play_frequency;
                            _this.edit_font_size = result.font_size;

                            _this.showList = false;
                            _this.showEdit = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            // 返回列表
            backList: function() {
                this.showList = true;
                this.showEdit = false;
            },
            // 保存
            editZmd: function() {
                let _this = this;
                let room_area = [],
                    room_id = [];
                for(var i in _this.area_item) {
                    room_area.push(_this.area_item[i]);
            　　}
                for(var i in _this.box_item) {
                    room_id.push(_this.box_item[i]);
            　　}
                if(_this.all_shops == '1'){
                    room_area = [];
                    room_id = [];
                }else{
                    if( _this.area_item.length == 0 && _this.box_item.length == 0 ) {
                        layer.msg("包厢区域和包厢号必须二选一");
                        return false;
                    }
                }
                const content = _this.edit_play_content.replace(/\n/g, ' ')
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": $(_this.$refs.edit_shop).val(),
                            "number": _this.edit_play_number, // 播放序号
                            "content": content, // 播放内容
                            "color": _this.font_item, // 颜色
                            "play_times": _this.add_play_dateModel,
                            "start_date": _this.startDate, // 播放开始日期
                            "end_date": _this.endDate, // 播放结束日期
                            "start_time": _this.editAllParams.start_time,
                            "end_time": _this.editAllParams.end_time,
                            "play_frequency": _this.edit_play_frequency,
                            "font_size": _this.edit_font_size,
                            "room_area": room_area,
                            "room_id": room_id,
                            "all_shops": _this.all_shops
                        }
                    },
                    "comment": ""
                };
                if(_this.modify == '2') {
                    datas.request.param.id = _this.theBrinter.id;
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Setting/setScrollingText",
                    async: false,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code']=="true"){
                            layer.msg(data["response"]["error_msg"]);
                            _this.showList=true;
                            _this.showEdit=false;
                            _this.initTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            
        }
    }
</script>
<style lang="less">
    .add_play_date_everyday_div {
        label {
            margin-left: 10px;
        }
    }
    .zoumadeng-set {
        .zmd-edit {
            p {
                color: #ff0707;
            }
            .multi-select {
                i {
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    border-radius: 50px;
                    margin-top: 10px;
                    &.color_1 {
                      background: green;
                    }
                    &.color_2 {
                      background: white;
                    }
                    &.color_3 {
                      background: red;
                    }
                    &.color_4 {
                      background: orange;
                    }
                    &.color_5 {
                      background: blue;
                    }
                    &.color_6 {
                      background: yellow;
                    }
                    &.color_7 {
                      background: violet;
                    }
                    &.color_8 {
                      background: green;
                    }
                }
            }
            .add_play_frequency_company {
                display: inline-block;
                position: absolute;
                right: 0px;
                margin-right: 15px;
                font-size: 14px;
                padding-right: 5px;
                height: 32px;
                line-height: 32px;
            }
            .play_content {
                resize: none;
                height: 140px !important;
                margin: 0 0 30px;
            }
            .add-play-date {
                position: relative;
            }
          
          
            .canselect {
                background-color: #eee !important;
            }
        }
        .room-wrapper {
            margin: 20px 0;
            border: 1px solid #f5f5f5;
            .block-title {
                line-height: 40px;
                background: #f5f5f5;
                padding-left: 20px;
            }
            .block {
                margin-top: 20px;
                .rooms {
                    padding: 10px 20px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;
                    .room {
                        width: 200px;
                        margin: 10px 0;
                    }
                }
            }
        }
    }
</style>